var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 100 100"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 6,
    x: 20,
    y: 46,
    rx: 4,
    transform: "rotate(45 50 50)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 6,
    x: 20,
    y: 46,
    rx: 4,
    transform: "rotate(-45 50 50)"
  })));
};
export default SvgX;